export default __webpack_public_path__ + "static/media/logo (copy).3d5668c4.svg";